import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { User } from 'src/app/classes/user.class';
import { CodaltComponent } from 'src/app/codalt.component';
import { Address, LocationService } from 'src/app/services/location.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-transport-address',
    templateUrl: './transport-address.component.html',
    styleUrls: ['./transport-address.component.scss'],
    standalone: false,
})
export class TransportAddressComponent extends CodaltComponent implements OnChanges, OnInit {
    @Input() users: User[];
    @Input() address: string | Address;
    @Input() planning: PlanningHasEntity;

    @Input() main: PlanningHasEntity;

    @Input() placeholder: string;

    @Input() fc: FormControl;

    @Input() fg: FormGroup;

    @Input() hasNext: boolean;
    @Input() isOrigin: boolean;

    addresses: string[];
    fcSearch = new FormControl();
    addressVisible = true;

    driverAddress: string;

    worksiteAddress: string;

    companyAddress: string;

    isFocussed = false;

    icon: 'own' | 'dvds' | 'else' | 'work' | 'next' | 'none';

    constructor(private locationService: LocationService) {
        super();
        this.companyAddress = this.locationService.formatAddress(environment.companyAddress);
    }

    ngOnInit() {
        if (this.fc.disabled) {
            this.fcSearch.disable();
        }
        this.subscriptions.add(
            this.locationService
                .searchLocations(this.fcSearch.valueChanges, 'TransportAddressComponent.ngOnInit')
                .subscribe(result => {
                    this.addresses = result.map(address => address.formattedAddress);
                })
        );
        this.subscriptions.add(
            this.fg
                .get('driver_user_id')
                ?.valueChanges.pipe(debounceTime(300))
                .subscribe(() => {
                    this.updateAddresses();
                })
        );
        this.subscriptions.add(
            this.fc.valueChanges.subscribe(() => {
                this.updateAddresses();
            })
        );
        this.subscriptions.add(
            this.fc.statusChanges.subscribe(() => {
                if (this.fc.disabled) {
                    this.fcSearch.disable();
                } else {
                    this.fcSearch.enable();
                }
            })
        );
    }

    updateAddresses() {
        this.driverAddress = this.locationService.formatAddress(
            this.users.find(u => u.id === this.fg.get('driver_user_id').value) as any
        );
        let worksiteAddress = this.fg.get('transport_worksite').value;
        if ([this.driverAddress, this.address, this.companyAddress].includes(worksiteAddress)) {
            worksiteAddress = null;
        }
        this.worksiteAddress = worksiteAddress;
        this.setIcon();
    }

    ngOnChanges(): void {
        this.updateAddresses();
    }

    optionSelected(event: any) {
        this.fc.setValue(event.option.value);
        this.fc.markAsDirty();
        this.fcSearch.setValue('');
        this.setIcon();
        setTimeout(() => {
            window.focus();
            if (document.activeElement) {
                (document.activeElement as HTMLElement).blur();
            }
        });
    }

    setIcon() {
        if (!this.users || !(this.fc.value?.length > 0)) {
            this.icon = 'else';
            this.addressVisible = true;
            return;
        }
        this.addressVisible = false;
        if (this.main.planning?.location === this.fc.value) {
            this.addressVisible = true;
            this.icon = 'work';
        } else if ('next' === this.fc.value) {
            this.icon = 'next';
        } else if ('none' === this.fc.value) {
            this.icon = 'none';
        } else if (this.companyAddress === this.fc.value) {
            this.icon = 'dvds';
        } else if (this.driverAddress === this.fc.value) {
            this.icon = 'own';
        } else {
            this.addressVisible = true;
            this.icon = 'else';
        }
    }
}
